import React, { useState, useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);

const path = process.env.PUBLIC_URL

const quotes = [
  {
    text: "<p>日本不是年年都有“年度汉字”吗，我的年度汉字就是“逃”。我当时去日本的随身背包里，带着两本书，一本是《大逃港》、一本是《圣经》，在机场的候机大厅，我一直在读“出埃及记”。</p><p>我曾经两次爬过深圳的梧桐山，那是最著名的大逃港路线， 从1949年到1980年，有上百万人冒死走上逃亡去香港的道路；而当时那些逃亡者的后代，也就是香港的年轻人在抗争后又要再次逃离共产党的统治。这两次逃亡都令我非常触动，而前人逃亡的路就是我现在的路。我的状态和当时的逃亡者是一样的，就是要到一个适合人类生活的地方去。</p><p>我瞒着家里人用了将近5年的时间筹划去日本读书，主要就是打工攒钱，并在这段时间里自学日语。为了能攒下钱，我返回了自己家乡找工作，这样能够省下房租和一部分饭费。这几年我做过信贷公司、当过炒票的黄牛、也给广告公司打工写过软文。</p><p>每次拿到工资，我会把拿出一部分换成美金，每月500美金。我四年多后存下了24,000美金用来支付中介费、一年的语言学校学费、住宿费、机票和各类杂费。</p><p>我以后期望在日本的技术学校学习电子应用工程。我的中国同学觉得学历越高就越不应该做技工，不过对我来说，用劳动，特别是有技能的劳动去换取工作是很正常的事。</p>",
    name: "黄铠",
    tag: "学生，28岁，广东人，润到日本",
    pic: "profile1"
  },
  {
    text: "<p>我们在国内都是普通人，以后的生活注定是平平淡淡的。出国一方面是为自己，趁还年轻想出去看看，尝试新的生活方式。另一方面是为了小孩，我们在国内‘鸡娃’也鸡不出来，国外更自由、公平，对小孩也好一些。</p><p>我们19年就和中介签了约，付了15万加币，走加拿大的雇主担保。中介第一次给我老公匹配的雇主失败了，因为移民局认为雇主资格不够。中介不会保证帮你办理成功，只能说不成功的话再换项目，但退钱应该不可能。后来，耽搁了快一年，我老公才走成了。</p><p>我老公一开始不想出来的，他大学一毕业就在外企工作，很稳定，收入也不低。后来也是被我逼得没办法了，他自己也想开了。但即便以后拿到身份，他也很难找到在上海时那样的工作了。所以有朋友来问我们在加拿大的生活的时候，我老公就言简意赅地说，如果你想为小孩好，就带孩子出来，如果你想安安稳稳的对自己好的，就不要出来。</p><p>带小孩上飞机那天，我记得特别清楚，是2月28日。我到达温哥华后的一个礼拜，微信里就有朋友说他们居住的小区有阳性病例，整个小区都封了。后来上海发生了什么，整个世界都知道了。</p>",
    name: "莫莉",
    tag: "前家庭主妇，35岁，上海人，润到加拿大",
    pic: "profile0"
  },
  {
    text: "<p>我曾经是海归，润出去前在上海一家公司做数据分析。这几年我其实一直是政治抑郁状态，因为关心社会议题，经常在微博上发表观点，后来被炸号，也多次被警察骚扰。越来越紧缩的环境让我很不安，我想给自己找个Plan B。</p><p>最终让我下定决心的是上海封城。那时我拿到了一所欧洲大学的offer，申请时本来没想好一定要去，结果却变成了我的救命稻草。我想都没想就接受了，也和男朋友约定好，毕业找到工作后会把他也带出来。</p><p>我和爸妈的关系一般，出国的费用是我自己的存款加上从几个朋友那借的钱。朋友都很理解，甚至都没问我为什么要走，她们很多人也在计划润。</p><p>和爸妈说了要出国的事后，他们显得不大愿意。虽然我家里只有我和姐姐，但我觉得父母还是对女儿有偏见。姐姐大学毕业后，本想留在学校所在的城市工作，却被爸妈劝回了老家。</p><p>这次出国不是抱着“我要探索新世界”的心态，而是“我需要到一个熟悉的环境重建我的身心健康。”之前一直被压着，很无力很痛苦，很害怕他们拿捏着我的一切，可以随时上门找到我。现在感觉这些压力都从我身上撤走了，我可以大胆地恨了。</p>",
    name: "肉桂",
    tag: "前数据分析师，28岁，上海人，润到西欧",
    pic: "profile2"
  },
  {
    text: "<p>我本科读的是公共管理，为了好找工作又去读计算机，没读完就润了。我是跨性别，又有双向情感障碍。开始使用激素后，我被父母赶出了家门。</p><p>我离家后不久就遇到疫情封控，那段时间精神状况很糟糕，甚至没有力气维生。再加上我又很关注社会事务，看到跨性别伙伴的处境，有好几个人自杀，就觉得逃离是唯一的出路。</p><p>我只想正常地活下去，被当成人对待。没有选择、不得不离开的情绪大于对外面的向往。继续留在国内的话，我觉得会面临和自杀的伙伴们一样的结局。</p><p>我先去了香港，然后买了去塞尔维亚的机票，特地选了在瑞士中转。到了瑞士之后我就“跳机”了，去海关寻求了庇护。</p><p>在香港的时候，我给父母打电话求救。我请求他们带我去医院，否则我只能去偷渡，可能会遭遇生命危险，但是却被拒绝了，父母觉得一切都是我自己的问题，还说“你千万不要回家”。</p><p>到了苏黎世，我被安置在一个大学的防空洞里面，有吃住，有一些零花钱，可以获得基础医疗服务。会有律师来了解个人情况，帮助我上庭，然后政府才会决定接纳还是拒绝我。</p><p>现在支撑着我的希望就是，我想向更多人讲出自己的故事，引起社会对跨性别者的关注。如果有像我一样的孩子听到了，哪怕可以多活一段时间也好。</p>",
    name: "以翎",
    tag: "前大学生，23岁，北京人，润到瑞士",
    pic: "profile3"
  },
  {
    text: "<p>我应该是赶在新疆“再教育营”兴起之前，最后一批能逃出来的维吾尔人。</p><p>念中学时候，我经历了乌鲁木齐“七五事件”。那时我的汉人朋友也开始上街反对维吾尔人。街上那些不认识的汉人望着我的眼睛，都充满了仇恨。我第一次有想要离开中国的念头。</p><p>从小我便在新疆的汉人学校读书。我曾经认为，只要掌握好汉语，维人是可以成功的。后来我在家乡参加铁路设计比赛，得了第一名，先后在四川、北京留学，并加入共产党。大约20岁出头，我便在在铁路公司担任副科长一职。</p><p>努力融入并没有让我免于歧视。我记得有一次搭火车的时候，汉人职员全上车了，只有我被公安拦下，被安排到一个只有维吾尔人的车厢里，我很愤怒，但是公安说：“一切只是为你好。”这让我明白，我跟他们（汉人）不一样，中国仍然是以汉族为主。</p><p>我第一次申请到美国的语言学校去办护照，多次被政府拒绝，当我完成一个要求，他们又会制造另一个要求，不断不断有新的理由拒绝。我托汉人朋友去打听，花了一万人民币收买相关官员，才取得护照。后来又两次报团去土耳其及日本旅行，之后再申请到日本读书。</p><p>当时一心想着，只要是逃到民主国家便好了，我不想待在极权国家。就算放弃铁路公司的工作，我也要坚决离开新疆。</p>",
    name: "Sawut Muhammad",
    tag: "日本维吾尔族协会理事，30岁，维吾尔人，润到日本",
    pic: "profile4"
  },
  {
    text: "<p>我在山东一个县城做过五年警察。在体制内我算一个受益者，虽然在公安基层接触到一些看不惯的东西，但我也改变不了。只希望自己能有机会跳出县城，到市局、到更高的地方去，于是我报考了警校的研究生。</p><p>意外是在读研时发生的。2019年夏天，我发微博骂了当时的外交部发言人耿爽，被粉红大V“上帝之鹰”挂出来，网警找到了学校。退学是我和学校交涉来的，不退学就会被开除。</p><p>那一年发生了很多事，让我对体制更加失望。香港反修例运动期间，我翻墙读了很多文章。如果只关注国内媒体，对香港的看法一定是一边倒的，但其实墙外人都知道香港发生了什么，几百万人为什么要上街。</p><p>退学后我就萌生了出国的念头，但没钱付诸行动。我发现自己除了做警察并没有其他技能，离开政府我其实什么也不是。接下来的三年里，我做过各种各样的工作，到2021年从最后一份工作离开，就彻底绝望了。</p><p>我在新闻里听说有水手通过“跳船”的方式偷渡加拿大，就去报了海员培训班。学习期间我偶然在电报上看到有人分享“走线”的信息，一开始觉得简直是天方夜谭。但渐渐看到越来越多人成功的经历，就觉得这是一条更实际的途径。</p><p>一旦下了决心，事情就容易了。2022年6月底，我借了七万人民币作路费，踏上了去往南美的旅程。</p>",
    name: "Tianwei",
    tag: "前警察，31岁，山东人，润到美国",
    pic: "profile5"
  }
]

function Quote({ moving }) {
  const [currentIndex, setCurrentIndex] = useState(0)
  const [scroll, setScroll] = useState(false)
  
  // useEffect(() => {
  //   const element = document.getElementById("scroller");
  //   if ( === false && scroll === true) {
  //     gsap.to(window, {duration: 0.2, scrollTo: "#scroller"});
  //     setScroll(false);
  //   }
  // }, [moving, scroll]);

  const srolltoTop = () => {
    gsap.to(window, {duration: 0.2, scrollTo: "#scroller"});
  }

  let p_wrap, container
  
  useEffect(() => {
    const p_wrap = document.getElementById("p-wrap");
    const container = document.getElementsByClassName("mask-wrap")[0];
  }, []);

  return (
    <div className='quote scroller' id="scroller">
      <section className='container quote__wrapper' id="quote">
        {/* <div className='container'> */}
        <div className="left-wrap">
          <div className="text-wrap">
            <div className='mask-wrap'>
              <div className="p-wrap" id="p-wrap">
                {quotes.map((quote, index) => (
                  <div key={index} className={`panel ${index === currentIndex ? "active" : ""}`} dangerouslySetInnerHTML={{ __html: quote.text }} />
                ))}
              </div>
            </div>
            
          </div>
          <img className="quote__mark" src={`${path}/quote.png`} />
        </div>
        <div className="image-wrap">
          {quotes.map((quote, index) => (
            <div key={index} className={`panel-image ${index === currentIndex ? "active" : ""}`}><img src={`${path}/${quote.pic}.png`} /></div>
          ))}
          <div className="tag__wrapper">
            <div className='name'>{quotes[currentIndex].name}</div>
            <div className='tag'>{quotes[currentIndex].tag}</div>
          </div>
          <div className="btn-wrap">
            {quotes.map((quote, index) => (
              <button key={index} className={`btn btn${index} ${currentIndex === index ? "active" : ""}`} onClick={() => { setCurrentIndex(index); srolltoTop();}}>
                0{index + 1}
              </button>
            ))}
          </div>
        </div>
        {/* </div> */}
      </section>
    </div>
  );
}

export default Quote;